jQuery(document)
.ready(function () {
	// `ckdc` object is provided by WP PHP, see class-ratings-js-config.php

	const RATE_RECIPE_BTN_DESKTOP_ID = 'rate_recipe_btn_desktop'
	const RATE_RECIPE_BTN_MOBILE_ID = 'rate_recipe_btn_mobile'
	const RATE_RECIPE_BTN_CLASS = 'rate_recipe_btn'

  // parses json with wp debug data in beginning
  const parseResponse = (responseStr) => {
    try {
      return JSON.parse(responseStr)
    } catch(e) {
      try {
        return JSON.parse(responseStr.substr(responseStr.indexOf('{"')))
      } catch {
        throw e // throws original error
      }
    }
  }

	const submitRating = (args) => {
		jQuery
		.post({
			type: 'POST',
      dataType: "text", // get response as plain text
			url: ckdc.ajaxurl,
			data: {
				nonce: ckdc.rating.nonce,
				action: 'submit_rating',
				dataType: 'json',
				recipeIdToken: args.itemId,
				rating: args.rating,
				feedback: args.feedback,
			},
			success: (resp) => {
				ckdc.events.recipe('recipe_rated', args.itemId);
				if ( typeof dataLayer === 'object' ) {
					dataLayer.push({
						event: 'recipeRated',
						rating: args.rating,
						recipeId: args.itemId
					});
				}

				try {
					// try to parse response manually
					const parsedResponse = parseResponse(resp)
					args.success(parsedResponse.data)

					// Remove "Rate recipe" buttons once the recipe was successfuly rated.
					document.querySelectorAll('.' + RATE_RECIPE_BTN_CLASS).forEach(btn => btn.remove())
        } catch {
					args.error(ckdc.rating.translations.error)
				}
			},
		})
		.fail(() => {
			args.error(ckdc.rating.translations.error)
		})
	}

	const ratingsDesktop = ratings.Ratings({
		...ckdc.rating,  ...{onSubmitRating: submitRating}
	})

	const mobileRatings = {
		...ckdc.rating,
		ratingTarget: ckdc.rating.ratingMobileTarget,
		detailedRatingTarget: ckdc.rating.detailedRatingMobileTarget
	}
	const ratingsMobile = ratings.Ratings({
		...mobileRatings, ...{onSubmitRating: submitRating}
	})

	const recipeButtonDesktopElement = document.getElementById(RATE_RECIPE_BTN_DESKTOP_ID)
	const recipeButtonMobileElement = document.getElementById(RATE_RECIPE_BTN_MOBILE_ID)

	if (recipeButtonDesktopElement) {
		recipeButtonDesktopElement.addEventListener('click', () => ratingsDesktop.showSubmitRatingModal())
	}

	if (recipeButtonMobileElement) {
		recipeButtonMobileElement.addEventListener('click', () => ratingsMobile.showSubmitRatingModal())
	}
});
